/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../common/glyph/glyph_icon';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "spos": {
            "nested": {
              "debitcard_management": {
                "nested": {
                  "atm_limits": {
                    "nested": {
                      "DebitCardATMLimit": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "limitAmount": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "subtitle": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "progressBar": {
                            "type": "squareup.bbfrontend.spos.debitcard_management.atm_limits.DebitCardATMLimit.ProgressBar",
                            "id": 4,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "ProgressBar": {
                            "fields": {
                              "percentage": {
                                "type": "double",
                                "id": 1,
                                "rule": "optional"
                              },
                              "barColor": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "amount": {
                                "type": "squareup.bbfrontend.spos.debitcard_management.atm_limits.DebitCardATMLimit.ProgressBar.Amounts",
                                "id": 3
                              },
                              "message": {
                                "type": "squareup.bbfrontend.spos.debitcard_management.atm_limits.DebitCardATMLimit.ProgressBar.Message",
                                "id": 4
                              }
                            },
                            "nested": {
                              "Amounts": {
                                "fields": {
                                  "usedAmount": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "remainingAmount": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "Message": {
                                "fields": {
                                  "glyphIcon": {
                                    "type": "squareup.bbfrontend.common.glyph.GlyphIcon",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "message": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "info": {
                                "oneof": ["amount", "message"]
                              }
                            }
                          }
                        }
                      },
                      "DebitCardATMLimitsScreen": {
                        "fields": {
                          "atmLimits": {
                            "type": "squareup.bbfrontend.spos.debitcard_management.atm_limits.DebitCardATMLimit",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.spos?.nested?.debitcard_management?.nested?.atm_limits?.nested?.DebitCardATMLimit && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.spos?.nested?.debitcard_management?.nested?.atm_limits?.nested?.DebitCardATMLimit?.nested?.ProgressBar && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.spos?.nested?.debitcard_management?.nested?.atm_limits?.nested?.DebitCardATMLimit?.nested?.ProgressBar?.nested?.Amounts && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.spos?.nested?.debitcard_management?.nested?.atm_limits?.nested?.DebitCardATMLimit?.nested?.ProgressBar?.nested?.Message && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.spos?.nested?.debitcard_management?.nested?.atm_limits?.nested?.DebitCardATMLimitsScreen) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DebitCardATMLimit @ squareup/bbfrontend/spos/debitcard_management/atm_limits/debitcard_atm_limits.proto at 12:1
 */
export const DebitCardATMLimit = $root.lookupType('squareup.bbfrontend.spos.debitcard_management.atm_limits.DebitCardATMLimit');
fixType(DebitCardATMLimit, {
  name: {
    notEmpty: true
  },
  limitAmount: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DebitCardATMLimit);
/**
 * SOURCE ProgressBar @ squareup/bbfrontend/spos/debitcard_management/atm_limits/debitcard_atm_limits.proto at 20:3
 */
DebitCardATMLimit.ProgressBar = $root.lookupType('squareup.bbfrontend.spos.debitcard_management.atm_limits.DebitCardATMLimit.ProgressBar');
fixType(DebitCardATMLimit.ProgressBar, {
  percentage: {
    required: true
  },
  barColor: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DebitCardATMLimit.ProgressBar);
/**
 * SOURCE Amounts @ squareup/bbfrontend/spos/debitcard_management/atm_limits/debitcard_atm_limits.proto at 29:5
 */
DebitCardATMLimit.ProgressBar.Amounts = $root.lookupType('squareup.bbfrontend.spos.debitcard_management.atm_limits.DebitCardATMLimit.ProgressBar.Amounts');
fixType(DebitCardATMLimit.ProgressBar.Amounts, {
  usedAmount: {
    notEmpty: true
  },
  remainingAmount: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DebitCardATMLimit.ProgressBar.Amounts);
/**
 * SOURCE Message @ squareup/bbfrontend/spos/debitcard_management/atm_limits/debitcard_atm_limits.proto at 36:5
 */
DebitCardATMLimit.ProgressBar.Message = $root.lookupType('squareup.bbfrontend.spos.debitcard_management.atm_limits.DebitCardATMLimit.ProgressBar.Message');
fixType(DebitCardATMLimit.ProgressBar.Message, {
  glyphIcon: {
    required: true
  },
  message: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DebitCardATMLimit.ProgressBar.Message);
/**
 * SOURCE DebitCardATMLimitsScreen @ squareup/bbfrontend/spos/debitcard_management/atm_limits/debitcard_atm_limits.proto at 43:1
 */
export const DebitCardATMLimitsScreen = $root.lookupType('squareup.bbfrontend.spos.debitcard_management.atm_limits.DebitCardATMLimitsScreen');
fixType(DebitCardATMLimitsScreen);
Builder.createAndAttachToType(DebitCardATMLimitsScreen);